import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { Nfse } from './nfse.model';

@Injectable()
export class NfseService {

    headers = new HttpHeaders().set('X-Skip-Loader', 'true');


  postVisualizaNfsesPorFiltro(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/visualizatodas/', item, {  observe: 'response' })
  }

    postVisualizaNfsesPorFiltroAsync(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/visualizatodas/', item, {
        headers: this.headers,
        observe: 'response'
        });
    }

      buscaDadosGerais(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/busca-dados-gerais/', item, {
        headers: this.headers,
        observe: 'response'
        });
      }

    getVerificaSePossuiTemplate(filtro): Observable<HttpResponse<any>> {

        const params = filtro;

        return this.http.get(
            environment.webApiSaguiControlUrl + '/api/nfse/verificatemplaterps/', {
              observe: 'response',
              params })
    }

  getEmpresa(): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/nfse/visualizatodasempresas', { observe: 'response' })
  }

   getEmpresaAsync(): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/nfse/visualizatodasempresas', {
        headers: this.headers,
        observe: 'response'
        });
      }

  getListaServico(): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/servicolista/visualizatodas', { observe: 'response' })
  }

  getListaServicoCadastrados(empresaId): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/servicolista/visualizatodascadastradas/' + empresaId, { observe: 'response' })
  }

  retornoTardio(item:any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/processa-consulta-tardia/', item,  { observe: 'response' })
  }

  getClientePorNome(nome: any): Observable<HttpResponse<any>> {
    const params = new HttpParams().set('id', nome);
    return this.http.get(
       environment.webApiSaguiControlUrl +'/api/nfse/visualizaclientepornome',
      { observe: 'response', params }
    );
  }

  getNfse(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/nfse/visualiza/' + itemId, { observe: 'response' })
  }

  getNfseAsync(itemId: any): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/nfse/visualiza/' + itemId, {
        headers: this.headers,
        observe: 'response'
        });
}

  postNfse(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/inclui/', item, { observe: 'response' })
  };

  criarNfse(dto: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/criar', dto, { observe: 'response' })
  };

  editarNfse(dto: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/nfse/editar', dto, { observe: 'response' })
  };

  putNfse(item: any, itemId: number): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/nfse/atualiza/' + itemId, item, { observe: 'response' })
  };

  postProcessaNfse(item: any, itemId: number): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/processa/', itemId, { observe: 'response' })
  };

  postCalculaImposto(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/calculaimposto/', item, { observe: 'response' })
  };

  postGeraLinkImpressao(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/imprime/',
      item,
      { responseType: 'arraybuffer', observe: 'response' } // Recebe arraybuffer, que pode ser tratado como texto ou Blob
    );
  }

postGeraLinkImpressaoAsync(item: any): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/imprime/',
      item, {
        responseType: 'arraybuffer',
        headers: this.headers,
        observe: 'response'
        });
}

  corStatus(status: string): string {
  switch (status) {
    case '100':
    case '102':
    case '135':
    case '95':
      return 'sucesso';
    case '0':
    case '1':
      return 'pendente';
    case '105':
    case '2':
      return 'processando';
    case '101':
      return 'cancelado';
    case '':
    case null:
      return 'inexistente'
    default:
      return 'erro';
  }
}

  getNotaToolTip(parcela){

    if(parcela.nfseStatusProcessamento==101){
      return 'Nfs-e Cancelada'
    }

    if(parcela.nfseNumero!=null &&  parcela.nfseNumero!=""){

      return 'Nfs-e: '+ parcela.nfseNumero

    }

    if(parcela.nfeNumero>0 ){

      return 'Nf-e: '+ parcela.nfeNumero

    }

    if(parcela.nfeId>0 || parcela.nfseId>0 ){

      return 'Nota aguardando ser transmitida, clique para transmitir';

    }

    return 'Nota fiscal não gerada'
  }

     getImpressaoRPS(id: number): Observable<HttpResponse<any>> {
    return this.http.get(
      environment.webApiSaguiControlUrl + '/api/nfse/imprimerps/' + id,  { observe: 'response', responseType: 'text' as 'json' })
  }

  postCancelar(itemId: number): Observable<HttpResponse<any>> {
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/cancela/' + itemId, {}, { observe: 'response' })
  };

  postGerarNfseLoteRps(nfses: Nfse[]): Observable<HttpResponse<any>> {
    console.log(nfses, "teste");
    return this.http.post(
      environment.webApiSaguiControlUrl + '/api/nfse/processa-lote/', nfses, { observe: 'response' })
  }

  salvaContaParcelaEFatura(item: any): Observable<HttpResponse<any>> {
    return this.http.put(
      environment.webApiSaguiControlUrl + '/api/nfse/salva-contaparcela-fatura/', item, { observe: 'response' })
  }



  getCnaeByListaServico(listaServico: string): Observable<HttpResponse<any>> {
    return this.http.get(
      `${environment.webApiSaguiControlUrl}/api/nfse/cnae/${listaServico}`,
      { observe: 'response', responseType: 'text' }
    );
  }


  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {

  }
}
